// ─── DEBUG: Theme blocking check ─────────────────────────────────────────────


// ─── BAADMAY MODAL DIRECT FIX ────────────────────────────────────────────────
// VenoBox ka open method check karo
let baadmayOpening = false;

document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".baadmay-modal");
  if (!trigger) return;
  if (baadmayOpening) return;

  e.preventDefault();
  e.stopPropagation();



  if (typeof VenoBox !== "undefined") {
    new VenoBox({
      selector: ".baadmay-modal",
      closeColor: "#000",
      closeBackground: "transparent",
      overlayColor: "rgba(0,0,0,.75)",
      overlayClose: false,
      customClass: "baadmay-modal-container"
    });

    // Flag set karo, phir real click fire karo
    baadmayOpening = true;
    trigger.click();
    setTimeout(() => { baadmayOpening = false; }, 500);
  }
}, true);


// ─── Variant change pe Baadmay price update ───────────────────────────────────
// ─── Quick View ke andar variant change pe Baadmay price update ───────────────
document.addEventListener('change', function(e) {
  const variantInput = e.target.closest('[is-value]');
  if (!variantInput) return;

  const quickViewModal = e.target.closest('.hdt-main-product-quick-view');
  if (!quickViewModal) return;

  setTimeout(function() {
    const priceEl = quickViewModal.querySelector('hdt-price .hdt-money');
    if (!priceEl) return;

    const rawText = priceEl.textContent.replace(/[^0-9]/g, '');
    const newPrice = parseInt(rawText, 10) / 100; // ← 100 se divide

    console.log('💰 Quick view variant price:', newPrice);

    const wrapper = quickViewModal.querySelector('.baadmay-gateway-wrapper');
    const installmentEl = quickViewModal.querySelector('#baadmay-installment');

    if (!wrapper || !installmentEl) return;

    if (isNaN(newPrice) || newPrice > 30000) {
      wrapper.style.display = 'none';
      console.log('🙈 Baadmay hidden — price too high');
    } else {
      wrapper.style.display = '';
      const installment = Math.floor((newPrice * 1.15) / 3);
      installmentEl.textContent = installment;
      console.log('✅ Installment updated:', installment);
    }
  }, 1500);
});